import { getLinesCount } from '../common/statistics';
import { REF_NAMES } from './scrollButton';

const pricing = [
  [ 90, 80, 65, 55, 50 ],
  [ 80, 70, 55, 45, 40 ],
  [ 80, 70, 55, 45, 40 ],
  [ 70, 60, 45, 35, 30 ],
  [ 65, 55, 40, 30, 25 ]
];

const taxPhrase = 'Plus taxes & fees.';

const allPlansInclude = [
  {
    id: 1,
    title: 'Unlimited talk & text',
    description: 'Stay in touch and never worry about overage charges with unlimited Talk, Text and Data on the network more people rely on.'
  },
  {
    id: 2,
    title: '5G Nationwide / 4G LTE',
    description: 'Get unlimited access to our 5G Nationwide / 4G LTE network which provides the high speeds and reliability you\'ve come to expect. On 5G Start plan and Welcome Unlimited plan, your data may be temporarily slower than other traffic in times of congestion.<br/><br/>5G Nationwide available in 2,700+ cities. Requires a 5G-capable device inside the 5G Nationwide coverage area.'
  },
  {
    id: 3,
    title: 'Verizon Up rewards',
    description: 'With Verizon Up, you simply get more. More rewards. More access. More choices. Every month and then some. All to just say thanks for being with us.'
  },
  {
    id: 4,
    title: 'Mexico & Canada talk, text & data',
    description: 'Talk, text and use unlimited data when traveling in Mexico and Canada. Data speeds are reduced to 2G after 0.5 GB/day. Also includes Unlimited talk and text to Mexico and Canada when you are in the US.'
  },
  {
    id: 5,
    title: 'International texting',
    description: 'Unlimited texting from the US to over 200 countries and territories worldwide.'
  },
  {
    id: 6,
    title: 'Call Filter spam blocker',
    description: 'With Verizon Call Filter from Verizon, screen incoming calls and filter spam. Fine-tune your settings to automatically block high-risk calls by risk level. Upgrade to Call Filter Plus for $2.99/mo for one line or $7.99/mo for 3+ lines.'
  }
];

const Nationwide5GStart = {
  title: '5G Nationwide',
  subtitle: 'Reliable 5G performance',
  description: 'Get unlimited access to our 5G Nationwide network. When combined with 5G Ultra Wideband, you’ll get our fastest performance. Requires a 5G-capable device inside the 5G Nationwide coverage area. When network is experiencing heavy traffic, your data may be temporarily slowed.'
};

const UltraWideband5G = {
  title: '5G Ultra Wideband',
  subtitle: 'Our fastest 5G network experience,<br/>up to 10X faster',
  description: '5G Ultra Wideband is the fastest 5G network access we offer. Download apps, games, entire playlists and TV series in seconds. You\'ll also get 5G Ultra Wideband mobile hotspot and crystal-clear 4K Ultra High Definition video streaming when activated on a capable device. Plus access experiences from our exclusive 5G partners: Snapchat, Live Nation, Riot Games, and Niantic, launching throughout 2022. For full details, visit the <u>5G experience page</u> <span class="verizon-description-link">(https://www.verizon.com/5g/)</span>.<br/><br/>5G Ultra Wideband available only in parts of select cities and access requires a 5G Ultra Wideband-capable device inside the 5G Ultra Wideband coverage area. Depending on location, uploading is performed over 5G Ultra Wideband or 4G LTE.'
};

const UnlimitedPremiumNetworkAccess = {
  title: '<b>Unlimited</b> premium network access',
  description: 'Get unlimited high-speed data that isn\'t slowed based on how much data you use. You\'ll also get high-definition 720p video streaming on 5G Nationwide / 4G LTE when you activate it in your plan settings.',
  specialClass: '-unlimited-premium-access-min-height'
};

const PremiumNetworkAccess50 = {
  title: '<b>50 GB</b> premium network access, then&nbsp;unlimited data',
  description: 'Get 50 GB of 5G Nationwide / 4G LTE premium data per month. You’ll also get high-definition 720p video streaming on 5G Nationwide / 4G LTE when you activate it in your plan settings.<br/><br/>In times of congestion, your smartphone and mobile hotspot data may be temporarily slower than other traffic after exceeding 50 GB/mo/line of 5G Nationwide / 4G LTE data.'
};

const MobileHotspotData5 = {
  title: '<b>5 GB</b> premium mobile hotspot data, then&nbsp;unlimited lower-speed data',
  description: 'Get high-speed 5G/4G hotspot data that your other devices can use. Your smartphone becomes a Wi-Fi connection for devices like tablets, laptops, and more.<br/><br/>During times of congestion, 5G Nationwide / 4G LTE hotspot data may be temporarily slower than other traffic after 5 GB/mo of 5G Nationwide / 4G LTE smartphone data. After exceeding 5 GB/mo of 5G Ultra Wideband, 5G Nationwide, or 4G LTE data, you can still use hotspot at lower speeds of 3 Mbps when on 5G Ultra Wideband and 600 Kbps when on 5G Nationwide / 4G LTE for the rest of the month. 5G access requires a 5G-capable device.'
};

const MobileHotspotData25 = {
  title: '<b>25 GB</b> premium mobile hotspot data, then unlimited lower-speed data',
  description: 'Get high-speed 5G/4G hotspot data that your other devices can use. Your smartphone becomes a Wi-Fi connection for devices like tablets, laptops, and more.<br/><br/>During times of congestion, 5G Nationwide / 4G LTE hotspot data may be temporarily slower than other traffic after 25 GB/mo of 5G Nationwide / 4G LTE smartphone data. After exceeding 25 GB/mo of 5G Ultra Wideband, 5G Nationwide, or 4G LTE data, you can still use hotspot at lower speeds of 3 Mbps when on 5G Ultra Wideband and 600 Kbps when on 5G Nationwide / 4G LTE for the rest of the month. 5G access requires a 5G-capable device.'
};

const MobileHotspotData50 = {
  title: '<b>50 GB</b> premium mobile hotspot data, then unlimited lower-speed data',
  description: 'Get high-speed 5G/4G hotspot data that your other devices can use. Your smartphone becomes a Wi-Fi connection for devices like tablets, laptops, and more.<br/><br/>During times of congestion, 5G Nationwide / 4G LTE hotspot data may be temporarily slower than other traffic after 50 GB/mo of 5G Nationwide / 4G LTE smartphone data. After exceeding 50 GB/mo of 5G Ultra Wideband, 5G Nationwide, or 4G LTE data, you can still use hotspot at lower speeds of 3 Mbps when on 5G Ultra Wideband and 600 Kbps when on 5G Nationwide / 4G LTE for the rest of the month. 5G access requires a 5G-capable device.'
};

const CloudStorage600 = {
  iconName: 'cloud',
  title: 'Verizon Cloud 600 GB',
  description: 'Wirelessly back up and sync your contacts, photos, videos, messages & documents to the Verizon Cloud. 600 GB included with this plan, or upgrade to 2 TB for an additional $9/mo or Unlimited for an additional $14/mo.'
};

const TryPerks6 = {
  title: 'Try Disney+, Apple Arcade or Google Play Pass, and Apple Music for 6 months on&nbsp;us',
  titleMobile: 'Try Disney+, Apple Arcade or<br/>Google Play Pass, and Apple Music for&nbsp;6&nbsp;months&nbsp;on&nbsp;us',
  description: '<b>Disney+</b><br/>All the best stories from Disney, Pixar, Marvel, Star Wars, and National Geographic. First 6 months on us, then $7.99/mo plus tax after offer ends. One subscription can be shared with everyone on your account. Cancel anytime.<br/><br/><b>Apple Music</b><br/>With Apple Music, you can play 75 million songs ad-free, online or off. Immerse yourself in spatial audio with Dolby Atmos. And unlock amazing definition with lossless audio. A $9.99/mo value.<br/><br/><b>Apple Arcade or Google Play Pass</b><br/>Enjoy unlimited access to 180+ incredibly fun games across all your Apple devices, with no ads and no in-app purchases. After offer ends, Apple bills $4.99/mo plus tax. Cancel anytime.<br/><br/>Google Play Pass is your ticket to hundreds of awesome games and apps, completely free of ads and in-app purchases. Explore a curated collection with favorites like Stardew Valley and the Monument Valley series to award-winning indies like LIMBO and Dead Cells. $4.99/mo plus tax after offer ends. Cancel anytime.'
};

const huluDisneyESPN = {
  title: 'Hulu, Disney+, ESPN+ included',
  hideTitle: true,
  iconName: 'disney-bundle',
  description: 'Get the best in movies, shows, and sports with Disney+, Hulu, and ESPN+ included. There’s something for everyone with epic stories, tons of TV, and live sports. One subscription can be shared with everyone on your account. A $13.99/mo value, included on us for as long as you stay on an eligible plan.'
};

const AppleArcadeOrGooglePlay = {
  title: 'Apple Arcade or Google Play Pass included',
  hideTitle: true,
  iconName: 'arcade-gpp',
  description: 'Enjoy unlimited access to 180+ incredibly fun games across all your Apple devices, with no ads and no in-app purchases. A $4.99/mo value, included on us for as long as you stay on an eligible plan.<br/><br/>Google Play Pass is your ticket to hundreds of awesome games and apps, completely free of ads and in-app purchases. Explore a curated collection with favorites like Stardew Valley and the Monument Valley series to award-winning indies like LIMBO and Dead Cells. A $4.99/mo value.'
};

const AppleMusic6 = {
  title: 'Try Apple Music for 6 months on us',
  description: 'With Apple Music, you can play 75 million songs ad-free, online or off. Immerse yourself in spatial audio with Dolby Atmos. And unlock amazing definition with lossless audio, at no extra cost. A $9.99/mo value, included on us for 6 months. Cancel anytime.'
};

const AppleMusic = {
  title: 'Apple Music includedc',
  iconName: 'music',
  hideTitle: true,
  description: 'With Apple Music, you can play 75 million songs ad-free, online or off. Immerse yourself in spatial audio with Dolby Atmos. And unlock amazing definition with lossless audio, at no extra cost. A $9.99/mo value.'
};

const TravelPass = {
  iconName: 'travel-pass',
  title: '1 TravelPass day per month',
  description: 'Get 1 TravelPass® day each month, accumulating up to 12 days each year. TravelPass days give you unlimited talk, text and data in more than 185 countries for 24 hours, included each month on us for as long as you stay on this plan. TravelPass® days expire 12 months after issue date.'
};

const UpTo50off = {
  iconName: 'wearable',
  title: 'Up to 50% off a watch, tablet, hotspot, or Hum plan',
  description: 'Get up to 50% off one eligible plan for a qualifying smartwatch, tablet, hotspot, or Hum in-car Wi-Fi device.<br/><br/>Eligible plans and discounts: 50% off Unlimited and Unlimited Plus for tablets; Essential and Plus plans for mobile hotspot devices; Unlimited for HumX; Unlimited + In Car WiFi for Hum+; and Unlimited and Number Share Unlimited for smartwatches. $20 off Premium and Pro plans for mobile hotspot devices.'
};

const VerizonHomeInternet25 = {
  title: 'Verizon Home Internet for only $25/mo',
  description: 'Get up to 50% off your Verizon 5G Home or LTE Home internet plan, or get Fios internet and save with the Mobile + Home Discount. Both as low as $25/mo when enrolled in Auto Pay, where service is available.'
};

const headerButtons = {
  [REF_NAMES.Unlimited]: {
    title: 'Unlimited Plans',
    subtitle: 'Mix and match plans for you and your family.'
  },
  [REF_NAMES.Welcome]: {
    title: 'Welcome Unlimited',
    subtitle: 'Explore our entry-level 5G Unlimited plan.'
  }
};

const startUnlimited = {
  id: 4,
  name: "5G Start",
  description: "Connect on the go.",
  newPhoneText: 'Up to $400 towards a new phone',
  // newPhoneClasses: '-see-details',
  base: true,
  featuresTitle: "Unlimited 5G",
  features: [
    Nationwide5GStart,
    MobileHotspotData5
  ],
  perksTitle: 'Perks to try, on us',
  perks: [
    TryPerks6
  ],
  taxPhrase
};

const doMoreUnlimited = {
  id: 3,
  name: "5G Do More",
  description: "Staying mobile, even around the world.",
  newPhoneText: 'Up to $800 towards a new phone',
  // newPhoneClasses: '-see-details',
  featuresTitle: "Unlimited 5G Ultra",
  features: [
    UltraWideband5G,
    PremiumNetworkAccess50,
    MobileHotspotData25
  ],
  savingsTitle: 'Home internet savings',
  savings: [
    VerizonHomeInternet25
  ],
  perksTitle: 'Connectivity',
  perksNote: 'Up to $35.99/mo value included',
  perks: [
    UpTo50off,
    TravelPass,
    CloudStorage600
  ],
  other: [
    TryPerks6
  ],
  taxPhrase
};

const playMoreUnlimited = {
  id: 2,
  name: "5G Play More",
  description: "For all your entertainment needs.",
  newPhoneText: 'Up to $800 towards a new phone',
  // newPhoneClasses: '-see-details',
  featuresTitle: "Unlimited 5G Ultra",
  features: [
    UltraWideband5G,
    PremiumNetworkAccess50,
    MobileHotspotData25
  ],
  savingsTitle: 'Home internet savings',
  savings: [
    VerizonHomeInternet25
  ],
  perksTitle: 'Entertainment',
  perksNote: 'An $18.98/mo value included',
  perks: [
    huluDisneyESPN,
    AppleArcadeOrGooglePlay
  ],
  other: [
    AppleMusic6
  ],
  taxPhrase
};

const getMoreUnlimited = {
  id: 1,
  name: "5G Get More",
  description: "Fully loaded, plus music.",
  newPhoneText: 'Up to $800 towards a new phone',
  // newPhoneClasses: '-see-details',
  featuresTitle: "Unlimited 5G Ultra",
  features: [
    UltraWideband5G,
    UnlimitedPremiumNetworkAccess,
    MobileHotspotData50
  ],
  savingsTitle: 'Home internet savings',
  savings: [
    VerizonHomeInternet25
  ],
  perksTitle: 'Everything plus music',
  perksNote: 'Up to a $64.96/mo value included',
  perks: [
    huluDisneyESPN,
    AppleArcadeOrGooglePlay,
    AppleMusic,
    UpTo50off,
    TravelPass,
    CloudStorage600
  ],
  rateLabel: 'Our best plan ever.',
  taxPhrase
};

const welcomeUnlimited = {
  id: 5,
  name: "Welcome Unlimited",
  description: "Get the basics.",
  newPhoneText: 'Switch, keep your phone and<br/>we’ll help cover the cost.',
  newPhoneClasses: '-info-icon',
  base: true,
  featuresTitle: "Unlimited 5G",
  features: [
    Nationwide5GStart
  ],
  perksTitle: 'Perks to try, on us',
  perks: [
    TryPerks6
  ],
  taxPhrase,
  get price() { return pricing[this.id - 1][getLinesCount() - 1]; },
  selectTip: 'This plan will be applied to all phone lines on your account.'
};

const bau_plans = [
  getMoreUnlimited,
  playMoreUnlimited,
  doMoreUnlimited,
  startUnlimited
].map((el) => ({
  ...el,
  get price() { return pricing[this.id - 1][getLinesCount() - 1]; }
}));

const BAU = {
  welcomePlanId: welcomeUnlimited.id,
  plans: bau_plans,
  allPlansInclude,
  pricing,
  welcomePlans: [ welcomeUnlimited ],
  headerButtons: [ REF_NAMES.Unlimited, REF_NAMES.Welcome ]
};

export { headerButtons, BAU  };
